"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

/**
 * Formats a generic string value
 */
var StringFormat = function StringFormat(_ref) {
  var prefix = _ref.prefix,
      value = _ref.value;
  return "".concat(prefix).concat(value);
};

StringFormat.propTypes = {
  /** Prefix to use for the string */
  prefix: _propTypes["default"].any,

  /** Value to stringify */
  value: _propTypes["default"].any.isRequired
};
StringFormat.defaultProps = {
  prefix: ''
};
var _default = StringFormat;
exports["default"] = _default;